<script>
import {
  paymentMethodListEmits,
  paymentMethodListProps,
  usePaymentMethodList
} from "./mixin";
import PaymentMethod from "@/containers/payment-method";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import PopinMultiPay from "@/containers/popin-multi-pay";

export default {
  name: "PaymentMethodListMobile",
  components: {
    PaymentMethod,
    List,
    ListItem,
    PopinMultiPay
  },
  props: {
    ...paymentMethodListProps()
  },
  emits: ["displayCgv", ...paymentMethodListEmits()],
  setup(props, context) {
    const popinMultiPay = ref(null);
    const {
      selectedId,
      allPaymentMethods,
      modePaiementSelected,
      processPaiement,
      openPopinMultiPay,
      useDiscount
    } = usePaymentMethodList(props, context, popinMultiPay);

    return {
      selectedId,
      allPaymentMethods,
      modePaiementSelected,
      processPaiement,
      openPopinMultiPay,
      useDiscount,
      popinMultiPay
    };
  }
};
</script>

<template>
  <div>
    <template v-if="modePaiementHabituel">
      <p class="c-payment-method-list-mobile__step-subtitle u-mt-md u-mb-xs">
        Votre mode de paiement habituel
      </p>

      <PaymentMethod
        :payment-method="modePaiementHabituel.attributes"
        :payment-method-infos="paymentMethodsInfos[modePaiementHabituel.id]"
        :is-porteur-carte-cora="isPorteurCarteCora"
        :carte-cora-is-malin-plus="carteCoraIsMalinPlus"
        :is-porteur-carte-malin="isPorteurCarteMalin"
        :montant-total-ttc="montantTotalTtc"
        :use-discount="useDiscount(modePaiementHabituel)"
        :selected="selectedPaymentMethods === modePaiementHabituel.id"
        :tirelire="tirelire"
        @click="modePaiementSelected(modePaiementHabituel)"
        @processPaiement="processPaiement"
        @displayCgv="$emit('displayCgv')"
        @openPopinMultiPay="openPopinMultiPay"
      />
      <p class="c-payment-method-list-mobile__step-subtitle u-mt-md u-mb-xs">
        Les autres modes de paiement
      </p>
    </template>
    <List>
      <ListItem
        v-for="pm in paymentMethods"
        :key="pm.id"
      >
        <PaymentMethod
          :payment-method="pm.attributes"
          :payment-method-infos="paymentMethodsInfos[pm.id]"
          :is-porteur-carte-cora="isPorteurCarteCora"
          :carte-cora-is-malin-plus="carteCoraIsMalinPlus"
          :is-porteur-carte-malin="isPorteurCarteMalin"
          :montant-total-ttc="montantTotalTtc"
          :selected="selectedPaymentMethods === pm.id"
          :use-discount="useDiscount(pm)"
          :tirelire="tirelire"
          @click="modePaiementSelected(pm)"
          @processPaiement="processPaiement"
          @displayCgv="$emit('displayCgv')"
          @openPopinMultiPay="openPopinMultiPay"
        />
      </ListItem>
    </List>
    <PopinMultiPay
      ref="popinMultiPay"
      :modes-paiement="allPaymentMethods"
    />
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/payment-method-list.scss";
</style>
